"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetNavigationType = exports.getBurgerMenuHeight = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
var _hooks = require("../../hooks");
const useGetNavigationType = ({
  link,
  activeLinkType
}) => {
  const isMobile = (0, _hooks.useIsMobile)();
  const isLinkTypeCatalogue = link?.linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.Catalogue;
  const isActiveLinkTypeCatalogue = activeLinkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.Catalogue;
  const isCategory = activeLinkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.Category;
  const isInspiration = activeLinkType === 'Inspiration';
  const isBeautyAndTrends = activeLinkType === 'BeautyTips';
  const isBestOffers = activeLinkType === 'FocusPage';
  const isGifts = activeLinkType === 'Gifts';
  return {
    isCatalogue: isMobile ? isLinkTypeCatalogue : isActiveLinkTypeCatalogue,
    isCategory,
    isInspiration,
    isBeautyAndTrends,
    isBestOffers,
    isGifts
  };
};
exports.useGetNavigationType = useGetNavigationType;
const getBurgerMenuHeight = ({
  isActiveLink,
  isAlwaysActiveLink,
  burgerMenuHeight
}) => {
  if (isActiveLink) {
    return burgerMenuHeight;
  } else if (isAlwaysActiveLink) {
    return undefined;
  }
  return 0;
};
exports.getBurgerMenuHeight = getBurgerMenuHeight;
